<template>
  <div class="shorMsgStyle" :style="{ minHeight: pageHeight + 'px' }">
    <div class="stortBanner">
      <img
        src="./assets/images/bannerShort.png"
        alt=""
        width="100%"
        height="100%"
      />
    </div>
    <div class="stortCtn">
      <div class="title" v-if="shaorMsgIndex == 0" style="display:flex">
        <div style="margin-right: 5px;">
          <img
            src="./assets/images/shortDui.png"
            alt=""
            width="20px"
            height="20px"
            style="padding-top: 3px;"
          />
        </div>
        <div>您已投保成功！</div>
      </div>
      <div class="title" v-if="shaorMsgIndex == 1" style="display:flex">
        <div style="margin-right: 5px;">
          <img
            src="./assets/images/shortDui.png"
            alt=""
            width="20px"
            height="20px"
            style="padding-top: 3px;"
          />
        </div>
        <div v-if="detail.smsStatus == 1">
          {{ detail.message }}已为您投保成功！
        </div>
        <div v-else>活动方已为您投保成功！</div>
      </div>
      <div class="titleTextBox">
        <div class="titleText" v-if="shaorMsgIndex == 0">
          投保人数：{{ detail.num }} 人
        </div>
        <div class="titleText" style="height:100%">
          产品名称：{{ detail.title }}
        </div>
        <div class="titleText" style="display:flex; height: fit-content;">
          <div style="width:70px;text-align: left; min-width: 70px;">保障期限：</div>
          <div style="font-size:13px">{{ moment(detail.startDate).format("YYYY-MM-DD HH:mm:ss") }} 至 {{ moment(detail.endDate).format("YYYY-MM-DD HH:mm:ss") }}</div>
        </div>
        <div class="titleText" style="display:flex">
          <div style="width:70px;text-align: left;">保单号：</div>
          <span>{{ detail.insuranceCode }}</span>
          <!-- <span>{{ detail.insuranceCode }} {{ detail.num >= 2?'等':'' }}</span> -->
        </div>
        <div class="titleText" style="display:flex; height: fit-content;" v-if="detail.showInsure == 1">
          <div style="width:70px;text-align: left; min-width: 70px;">被保人：</div>
          <span>{{ parseTogetherInfos() }}</span>
        </div>
      </div>

      <div class="shortBtn" v-if="shaorMsgIndex == 0 && detail.insuranceCode != '10550006600746934140'">
        <div></div>
        <van-button class="btns" @click="downLoadFile()" v-if="!downShow">
          {{detail.insuranceCid == 8 || detail.insuranceCid == 13 || detail.insuranceCid == 27 || textBool?'下载凭证':'下载保单'}}
        </van-button>
        <van-button
          class="btns"
          style="width: 112px;"
          loading
          loading-text="加载中..."
          v-else>
        </van-button>
      </div>
    </div>
    <div class="safeguard">
      <div class="title">
        保障项目
      </div>
      <div class="tp" v-if="detailObj && detailObj.cycle">
        <div>承保年龄</div>
        <div>
          <div style="padding: 5px 0;">{{ detailObj&& detailObj.cycle && detailObj.cycle[0].startAge }}-{{ detailObj&& detailObj.cycle && detailObj.cycle[0].endAge }}周岁</div>
        </div>
      </div>
      <div class="tp">
        <div>保障期限</div>
        <div>
          <div style="padding: 5px 0;">{{ moment(detail.startDate).format("YYYY-MM-DD HH:mm:ss") }}</div>
          <div style="padding: 5px 0;">{{ moment(detail.endDate).format("YYYY-MM-DD HH:mm:ss") }}</div>
        </div>
      </div>
      <div class="tp" style="border: none;padding: 8px;" v-if="detailObj.summarys"></div>
      <div class="tp" v-for="(item,i) in detailObj.summarys" :key="i" style="border: none;padding: 5px 20px;" v-if="detailObj.summarys">
        <div style="display: flex;width: 82%;line-height: 16px;">
          <div style="border-radius: 50%;height: 10px;width: 10px;margin-right: 5px;background: #02d28b;margin-top: 2px;"></div>
          <div style="width: 94%;">{{ item.name }}</div></div>
        <div>
          <div style="padding: 5px 0;">{{ item.price }}</div>
        </div>
      </div>
      <div class="tp" v-if="detailObj.summarys"></div>
    </div>
    <div class="bar10px" v-if="shaorMsgIndex == 1"></div>
    <div class="stortCtn" v-if="shaorMsgIndex == 1" style="padding-right:5px;">
      <div class="title" style="display:flex">
        <div style="margin-right: 5px;">
          <img
            src="./assets/images/shortTip.png"
            alt=""
            width="23px"
            height="23px"
          />
        </div>
        <div style="line-height: 25px;">温馨提示</div>
      </div>
      <div class="titleTextBox">
        <div class="titleText">
          如您本人没有购买保险，则该保险由活动方为您购买。
        </div>
        <div class="titleText">请安心出行！</div>
      </div>
    </div>
    <div class="bar10px"></div>
    <div class="stortCtn">
      <div class="title">更多服务</div>
      <div class="titleTextBox">
        <div class="titleText">
          保单详情、理赔服务、更多资讯，请联系希望保。
        </div>
        <div class="titleText">
          客服电话：
          <a href="tel://4008-933-988"
            ><span style="color:#21C28F">4008-933-988</span></a
          >
        </div>
      </div>
    </div>

    <!-- <div class="zhe">
      <van-loading vertical color="#0094ff" text-color="#0094ff">
        <template #icon>
          <van-icon name="star-o" size="30" />
        </template>
        <span style="color: #0094ff !important;">加载中...</span>
      </van-loading>
    </div> -->
  </div>
</template>

<script>
import storejs from "store";
import moment from "moment";
import util from "@/libs/util";

import {
  Collapse,
  CollapseItem,
  Icon,
  Toast,
  Dialog,
  Loading,
  Button,
} from "vant";
export default {
  name: "useRouter",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [Button.name]: Button,
  },
  data() {
    return {
      moment: moment,
      pageHeight: window.innerHeight,
      publicData: storejs.get("publicData"),
      activeNames: [1],
      summarys: [],
      detail: {
        url: "/api/accountBill/prints.v2",
        id: 6316,
      },
      shaorMsgIndex: this.$route.params.q,
      downShow: false,
      detailObj:{},
      textBool:false
    };
  },
  watch: {},
  mounted() {
    console.log('this.$route.params',this.$route.params)
    this.textBool = this.$route.query.textBool
    this.init();
  },
  methods: {
    parseTogetherInfos(){
      if(this.detail.togetherInfos){
        let names = [];
        try {
          let persons = JSON.parse(this.detail.togetherInfos);
          persons.forEach(e => {
            names.push(e.n);
          })
          return names.length > 0 ? names.join('，') : '';
        } catch (error) {
          
        }
      }
      return '';
    },
    async init() {
      if (this.shaorMsgIndex == 0) {
        document.title = "投保人短信";
      } else {
        document.title = "被保险人短信";
      }
      this.getorderList();
    },
    async getorderList() {
      let res = await this.$http.get("/api/bill/getBillInfo", {
        params: {
          id: util.encryptId(this.$route.params.id),
          type: this.shaorMsgIndex == 0 ? 0 : 1,
        },
      });
      if (res.code == 0) {
        this.detail = res.t;
        let res1 = await this.$http.post("/api/insuranceProduction/get", {
          id: this.detail.productId,
        });
        console.log(JSON.parse(res1.t.plans),'plans')
       let arr = JSON.parse(res1.t.plans)
       arr.forEach(e=>{
        if(e.planCode == this.detail.planCode){
          this.detailObj = e
        }
       })
       console.log('内容',this.detailObj)
      } else {
        this.$toast(res.msg);
      }
    },
    async downLoadFile() {
      if(this.detail.insuranceCid == 8 | this.detail.insuranceCid == 13 | this.detail.insuranceCid == 27 || this.textBool){
        window.location.href= `https://c.baojbx.com/pdfhtml?id=${this.detail.id}&planCode=${this.detail.planCode}&billId=${encodeURIComponent(util.encryptId(this.$route.params.id))}`
      }else{
        // let downFileUrl1 =
        //       "http://m.baojbx.com" +
        //       this.detail.url +
        //       "?billId=" +
        //       this.$route.params.id;
        let downFileUrl1 = "https://m.baojbx.com" + this.detail.url + "?insuranceCode=" + this.detail.insuranceCode;
        Dialog.confirm({
          title: "提示",
          message: "部分手机需要在下载界面停留几秒后点击下载" + downFileUrl1,
          confirmButtonText: "前往下载",
          cancelButtonText: "返回查看",
        })
          .then(() => {
            // let downFileUrl =
            //   "http://m.baojbx.com" +
            //   this.detail.url +
            //   "?billId=" + util.encryptId(this.$route.params.id);
            let downFileUrl = "https://m.baojbx.com" + this.detail.url + "?insuranceCode=" + this.detail.insuranceCode;
            this.downShow = true;
            var LOADING = Toast.loading({
              message: '保单下载中，请稍后...',
              forbidClick: true,
              loadingType: 'spinner',
            });
            downloadPDF(downFileUrl)
            setTimeout(()=>{
                this.downShow = false;
                LOADING.clear();
            },10000)
          })
          .catch(() => {});
      }
    },
  },
  beforeDestroy() {
    this.downShow = false;
    console.log("页面离开了");
  },
};

function downloadPDF(url) {
  var link = document.createElement('a');
  link.href = url;
  // link.download = 'filename.pdf';
  link.target = "_blank"
  link.click();
}

</script>

<style lang="scss" scoped>
.shorMsgStyle {
  // padding: 15px;
  // box-sizing: border-box;
  padding-bottom: 50px;
  box-sizing: border-box;
  // background: whitesmoke;
  .stortBanner {
    height: 140px;
    width: 100%;
    background: whitesmoke;
  }
  .stortCtn {
    height: 100%;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: white;
    .title {
      font-size: 16px;
      // height: 50px;
      height: 100%;
      line-height: 28px;
    }
    .titleTextBox {
      width: 100%;
      font-size: 14px;
      color: #666;
      margin-top: 5px;
      .titleText {
        height: 28px;
        line-height: 28px;
      }
    }
    .shortBtn {
      width: 100%;
      height: 32px;
      font-size: 14px;
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      .btns {
        height: 32px;
        width: 90px;
        line-height: 32px;
        text-align: center;
        background: #21c28f;
        color: white;
      }
    }
  }
  .warnTip {
    height: 140px;
    width: 100%;
    background: white;
  }
  .shortBtm {
    height: 100%;
    width: 100%;
  }
}
.bar10px {
  height: 8px;
  background: rgba(244, 244, 244, 1);
  width: 100%;
}
.zhe {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.safeguard{
  width: 100%;
  color: #666;
  .title{
    width: 100%;
    margin: auto;
    background: rgba(244, 244, 244, 1);
    font-size: 16px;
    box-sizing: border-box;
    padding: 20px;
  }
  .tp{
    box-sizing: border-box;
    border-bottom: 1px solid rgba(244, 244, 244, 1);
    display: flex;
    align-items: center;
    padding:12px 20px;
    justify-content: space-between;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.shorMsgStyle {
}
</style>
